var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16361 6V6.165H7.32861H10.1636V6.835H6.49361V3.165H7.16361V6ZM6.82861 0.835C3.97649 0.835 1.66361 3.14787 1.66361 6C1.66361 8.85213 3.97649 11.165 6.82861 11.165C9.68074 11.165 11.9936 8.85213 11.9936 6C11.9936 3.14787 9.68074 0.835 6.82861 0.835ZM0.993613 6C0.993613 2.77713 3.60574 0.165 6.82861 0.165C10.0515 0.165 12.6636 2.77713 12.6636 6C12.6636 9.22287 10.0515 11.835 6.82861 11.835C3.60574 11.835 0.993613 9.22287 0.993613 6Z",
    fill: "#4F5660",
    stroke: "#4F5660",
    strokeWidth: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayClock);
export default __webpack_public_path__ + "static/media/GrayClock.c7427efb131a3541f285f05d9d0e5de0.svg";
export { ForwardRef as ReactComponent };